import { AppContextProvider } from "./shared/contexts/app-context/components/AppContext";
import {
    AppSidePanelContextProvider
} from "./shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { Stack } from "@mui/material";
import { ApplicationHeader } from "./features/application-header/containers/ApplicationHeader";
import { ModuleSelector } from "./features/module-selector/components/module-selector/ModuleSelector";
import {
    ApplicationWorkspace
} from "./features/application-workspace/components/application-workspace/ApplicationWorkspace";

export function ApplicationPage() {
    return (
        <AppContextProvider>
            <AppSidePanelContextProvider>
                <Stack
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '99.9vh'
                    }}
                >
                    <ApplicationHeader/>
                    <ModuleSelector />
                    <ApplicationWorkspace />
                </Stack>
            </AppSidePanelContextProvider>
        </AppContextProvider>
    );
}